<template>
	<div
		:class="cn(
			'shrink-0 bg-border',
			orientation === 'horizontal' ? 'h-px w-full' : 'h-full w-px',
			props.class
		)"
		v-bind="$attrs"
	/>
</template>

<script setup lang="ts">
import { cn } from '../../../utils/cn';

const props = withDefaults(
	defineProps<{
		orientation?: 'horizontal' | 'vertical';
		class?: string;
	}>(),
	{
		orientation: 'horizontal',
	},
);
</script>
